import type { Step } from "react-joyride";

export const contractCreateTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າສ້າງສັນຍາໃໝ່! ຫນ້ານີ້ຈະຊ່ວຍທ່ານສ້າງສັນຍາໃໝ່. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີຕື່ມຂໍ້ມູນສັນຍາໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="create-form-basic-info"]',
    content:
      "ນີ້ແມ່ນພາກຂໍ້ມູນສັນຍາ. ທ່ານຕ້ອງຕື່ມຊື່ສັນຍາ, ເລືອກປະເພດສັນຍາ, ແລະຕື່ມຂໍ້ມູນຄູ່ສັນຍາ. ຊ່ອງທີ່ມີເຄື່ອງຫມາຍ * ແມ່ນຊ່ອງບັງຄັບ.",
    placement: "top",
  },
  {
    target: '[data-tourid="create-form-duration"]',
    content:
      "ນີ້ແມ່ນພາກລະຍະເວລາ & ເງື່ອນໄຂ. ທ່ານຕ້ອງກຳນົດວັນທີເລີ່ມ ແລະ ວັນທີຫມົດອາຍຸຂອງສັນຍາ. ທ່ານຍັງສາມາດເລືອກຕໍ່ອາຍຸອັດຕະໂນມັດ ແລະ ກຳນົດໄລຍະເວລາແຈ້ງເຕືອນ.",
    placement: "top",
  },
  {
    target: '[data-tourid="create-form-administration"]',
    content:
      "ນີ້ແມ່ນພາກການບໍລິຫານ. ທ່ານສາມາດເລືອກຜະແນກ ແລະ ຜູ້ຮັບຜິດຊອບສຳລັບສັນຍານີ້ (ບໍ່ບັງຄັບ).",
    placement: "top",
  },
  {
    target: '[data-tourid="create-form-documents"]',
    content:
      "ນີ້ແມ່ນພາກເອກະສານ. ທ່ານສາມາດອັບໂຫຼດເອກະສານຫຼັກ ແລະ ເອກະສານແນບສະໜັບສະໜູນຂອງສັນຍາ. ເອກະສານຫຼັກຈະຖືກໃຊ້ເປັນເອກະສານສຳຄັນຂອງສັນຍາ.",
    placement: "top",
  },
  {
    target: '[data-tourid="create-form-notes"]',
    content:
      "ນີ້ແມ່ນພາກໝາຍເຫດ ແລະ ຂໍ້ຄວນລະວັງ. ທ່ານສາມາດຕື່ມໝາຍເຫດ, ຂໍ້ຄວນລະວັງ, ຫຼືເງື່ອນໄຂພິເສດຂອງສັນຍາ (ບໍ່ບັງຄັບ).",
    placement: "top",
  },
  {
    target: '[data-tourid="create-form-submit"]',
    content:
      "ນີ້ແມ່ນປຸ່ມບັນທຶກ. ຫຼັງຈາກຕື່ມຂໍ້ມູນສຳເລັດແລ້ວ, ກົດປຸ່ມນີ້ເພື່ອບັນທຶກສັນຍາ. ຖ້າທ່ານຢູ່ໃນໂໝດພັດທະນາ, ທ່ານຍັງສາມາດໃຊ້ປຸ່ມ 'Auto Fill' ເພື່ອຕື່ມຂໍ້ມູນຕົວຢ່າງ.",
    placement: "top",
  },
];
